import { Component, ElementRef, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { Platform } from '@ionic/angular';
import { ArrowKeysOptions } from 'src/app/_directives/ArrowKeysUseable.directive';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { TagEditPage } from 'src/app/_pages/new-settings/ticket-settings/tag-overview/tag-edit/tag-edit.page';
import { TagOverviewPage } from 'src/app/_pages/new-settings/ticket-settings/tag-overview/tag-overview.page';
import { TicketTagColored, BoardService, TicketTag } from 'src/app/_provider/boards/board.service';
import { DarkmodeService } from 'src/app/_provider/darkmode.service';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { GeneralService } from 'src/app/_provider/general.service';
import { SaveService } from 'src/app/_provider/save.service';
import { TicketEmployee } from 'src/app/_provider/tickets/ticket.service';

@Component({
    selector: 'app-tag-assign-input',
    templateUrl: './tag-assign-input.component.html',
    styleUrls: ['./tag-assign-input.component.scss'],
    standalone: false
})
export class TagAssignInputComponent implements OnInit {

  @ViewChild("tagsearch",{static: false}) tagSearch: ElementRef

  public selectTags: TicketTagColored[] = []
  public isInputOpen: boolean = false

  public searchText: string = ""

  public get showCreateTagButton(): boolean {
    return this.selectTags.length == 0 && this.searchText.length > 0
  }

  public arrowKeysOptions: ArrowKeysOptions = {
    selectedItem: 0,
    mouseOverItem: new EventEmitter<number>(null),
    mouseMove: new EventEmitter<boolean>(null),
    enterPressed: async (index: number) =>{
      if(this.showCreateTagButton) await this.createTagBySearchText()
      else if(this.isInputOpen) await this.addTag(index)
      
    }
  }

  constructor(
    public boardSrv: BoardService,
    private darkmode: DarkmodeService,
    private generalSrv: GeneralService,
    private feedback: FeedbackService,
    public ticketSrv: TicketEmployee.TicketService,
    private saveSrv: SaveService.Ticket,
    public platform: Platform
  ) { 
    // this.ticketSrv.newWorkstepSelected.subscribe(()=>this.isInputOpen = false)
  }

  ngOnInit() {
    this.search()
  }

  public search(){
    this.selectTags = this.boardSrv.tags.filter(t =>{
        return !this.ticketSrv.tags.find(tag => t.id == tag.id) && t.description.toLowerCase().includes(this.searchText.toLowerCase())
    }).map(tag => { 
      const rgb: { r: number; g: number; b: number; } = this.darkmode.hexToRgb(tag.color)
      return {
        id: tag.id,
        description: tag.description,
        hex: tag.color,
        rgba: `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.2)`
      }
    })
    this.arrowKeysOptions.selectedItem = 0
  }


  public async openInput(){

    if(!this.platform.is("capacitor")){
      this.isInputOpen = true
      this.tagSearch.nativeElement.focus()
      this.search()
    }else{
      await this.feedback.openModal(TagOverviewPage, {isSelect: true,  selectedTags: this.ticketSrv.tags, tagChanged: async (tag: TicketTagColored, toAdd: boolean)=>{
        if(toAdd) await this.saveSrv.addTagToTicket(tag.id)
        else await this.saveSrv.removeTagFromTicket(tag.id)
      }})
    }
  }

  public inputBlured(){
    if(!this.searchText) setTimeout(() => {
      this.isInputOpen = false
    }, 100);
  }

  public deleteTag(tag: TicketTagColored){
    this.saveSrv.removeTagFromTicket(tag.id)
    this.ticketSrv.tags.splice(this.ticketSrv.tags.findIndex( t => t.id == tag.id), 1)
  }
 
  public async addTag(index: number){
    if(!this.generalSrv.serverVersionGreaterThan("1.7.0")) return await this.feedback.showError("Um dem Ticket einen Tag hinzuzufügen, muss der Server auf Version 1.7.0 oder höher sein.")
    if(!this.selectTags[index]) return
    this.ticketSrv.tags.push(this.selectTags[index])
    this.saveSrv.addTagToTicket(this.selectTags[index].id)
    this.selectTags.splice(index, 1)
    this.arrowKeysOptions.selectedItem = 0
    this.searchText = ""
    this.search()
  }

  public async createTagBySearchText(){
    if(!this.showCreateTagButton) return
    const tag: TicketTagColored = {id: -1, description: this.searchText, hex: "#6576AD", rgba: `rgba(101, 118, 173, 0.1)`}
    const result: HttpFunctionResult<TicketTag> = await this.feedback.showModal<TicketTag>({
      component: TagEditPage,
      componentProps: { isNew: true, tag }
    })
    
    this.searchText = ""
    this.isInputOpen = false
    if(result.success) {
      this.boardSrv.tags.push(result.data)
      this.search()
      const index = this.selectTags.findIndex(t => t.id == result.data.id)
      if(index > -1) this.addTag(index)
    }
    
  }

}
